import { getAuthToken } from "@asayinc/component-library";
import { Box, Stack } from "@mui/material";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { SideNavigationBar } from "../../molecules/SideNavigationBar";

export function AppContainer() {
  const authToken = getAuthToken();

  useEffect(() => {
    document.title = authToken
      ? "Intermediary Portal | Say Technologies"
      : "Sign In | Say Technologies";
  }, [authToken]);

  return (
    <Box minHeight="100vh">
      <Stack flexDirection="row">
        {authToken && <SideNavigationBar />}
        <Box
          minWidth={600}
          m={"0 auto"}
          sx={{
            flex: 1,
            pb: 10,
          }}
        >
          <Outlet />
        </Box>
      </Stack>
    </Box>
  );
}
